module.exports = __webpack_public_path__ + "img/popup-game-sucai.306c004d.png";